// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

import type { Icon } from 'iconsax-react';

const UploadCloudArrowIcon: Icon = ({ size = 16, color, variant: _variant, className, style, ...rest }) => {
  const stroke = color || 'currentColor';
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="upload cloud arrow"
      className={className}
      style={style}
      {...rest}
    >
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="17 8 12 3 7 8" />
      <line x1="12" y1="3" x2="12" y2="15" />
    </svg>
  );
};

export { UploadCloudArrowIcon };
